import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import config from '../../config/config'
const PropertyDetails = () => {
  const { id } = useParams();
  const [propertyData, setPropertyOptions] = useState([]);
  const [imagesData, setImagesData] = useState([]);
  useEffect(() => {
    // 🏘️ Static mock property data
    config.getPropertyById({ "id": id }).then((res) => {
      setPropertyOptions(res.data);
      setImagesData(
        res?.data?.image
          ? res.data.image.split(",").filter((img) => img.trim() !== "") // ✅ split & clean up
          : [] // ✅ if no image field or empty
      );


      // Ensure it's an array of { id, name }
    });
  }, [id]);
  // guard for loading
  const isLoading = !propertyData || Object.keys(propertyData).length === 0;

  return (
    <>
      <section>
        <div className="head"></div>
      </section>

      {/* Property Hero Banner */}
      {!isLoading && propertyData.name && (
        <section className="hero" style={{backgroundColor: '#f5f5f5', minHeight: '25vh'}}>
          <div className="hero-content" style={{textAlign: 'left', width: '100%', maxWidth: '4xl', margin: '0 auto', padding: '40px'}}>
            <h1>{propertyData.name}</h1>
            {propertyData.address && <p>📍 {propertyData.address}</p>}
            {propertyData.price && <p style={{fontSize: '20px', fontWeight: 'bold', color: '#007bff'}}>Price: {propertyData.price}</p>}
          </div>
        </section>
      )}
      {/* Image Carousel */}
      <section className="featured">
        <div className="max-w-6xl mx-auto my-10 p-4">
          {/* <h2 className="text-2xl font-semibold mb-6 text-center">Our Agents</h2> */}

          <Swiper
            modules={[Navigation, Pagination, Scrollbar, A11y]}
            spaceBetween={30}
            slidesPerView={3}
            navigation
            pagination={{ clickable: true }}
            scrollbar={{ draggable: true }}
            // onSwiper={(swiper) => console.log(swiper)}
            // onSlideChange={() => console.log("slide change")}
            className="property-swiper"
          >
            {imagesData.map((n) => (


              <SwiperSlide key={n}>
                <div className="bg-white shadow rounded-lg overflow-hidden">
                  <img
                    src={`${config.IMAGE_URL}property/${n}`}
                    // src="https://media.istockphoto.com/id/1644622448/photo/new-houses-construction-residential-house-development.jpg?s=612x612&w=0&k=20&c=toO5Hy1DE-VZcZfJsgVPEmoWVB7VcxBf99WbB_SP49Y="
                    alt={`Slide ${n}`}
                    className="image"
                  />
                  {/* <div className="p-4">
                    <h3 className="font-semibold text-lg">Property {n}</h3>
                    <p className="text-gray-600">₹{n * 20000}/month</p>
                  </div> */}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>


        </div>

      </section>

      {/* Property Details */}
      <div className="max-w-4xl mx-auto p-6 bg-white rounded-lg shadow">
        {isLoading ? (
          <p>Loading property...</p>
        ) : (
          <>
            <h2 className="text-2xl font-semibold mb-3">{propertyData.name || 'Property'}</h2>
            {propertyData.price && <div className="mb-2 font-semibold">Price: {propertyData.price}</div>}
            <p className="text-gray-700 leading-relaxed">{propertyData.description}</p>

            <div className="mt-4">
              {propertyData.phone && <p>Contact: {propertyData.phone}</p>}
              {propertyData.email && <p>Email: {propertyData.email}</p>}
              {propertyData.address && <p>Address: {propertyData.address}</p>}
            </div>

            <div className="mt-6">
              <h3 className="font-semibold text-lg mb-2">Key Highlights:</h3>
              <ul className="list-disc pl-6 text-gray-600">
                <li>Spacious rooms with natural light</li>
                <li>Prime location with easy connectivity</li>
                <li>24x7 security and power backup</li>
                <li>Ready-to-move condition</li>
              </ul>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default PropertyDetails;
